import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MessageSquareIcon } from 'lucide-react';
import { SITE } from '../constants/site';
export function FinalCta() {
  return <section className="w-full bg-nfgreen py-16 sm:py-24" data-id="element-42" data-mp="19eyyx5dc8tyh">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8" data-id="element-43" data-mp="19gifkx2wp70s">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-44" data-mp="15capavgsvj0g">
          <h2 className="font-display text-3xl font-extrabold text-white sm:text-5xl" data-id="element-45" data-mp="1ediodfr54nvl">
            This is your lawn. Your property. Your investment.
          </h2>
          <p className="mt-5 text-lg text-green-50 sm:text-xl" data-id="element-46" data-mp="1o3lffaepbrra">
            One call is all it takes to find out exactly what's wrong and exactly what
            it costs to fix it. No pressure. No obligation.
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-47" data-mp="1x5umtreob50g">
            <a href={SITE.phoneHref} className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 py-4 text-base font-bold text-nfgreen-dark shadow-lg transition-transform hover:scale-[1.03]" data-id="element-48" data-mp="n6w72z5gtqc7">
              <PhoneIcon className="h-5 w-5" data-id="element-49" data-mp="x2h38gnurwe1" />
              Call Now: {SITE.phone}
            </a>
            <a href={SITE.smsHref} className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white px-8 py-4 text-base font-bold text-white transition-colors hover:bg-white/10" data-id="element-50" data-mp="1246gm2yjsm5a">
              <MessageSquareIcon className="h-5 w-5" data-id="element-51" data-mp="1b1qgb7griads" />
              Text Us
            </a>
          </div>
          <p className="mt-6 font-display text-lg font-bold italic text-white" data-id="element-52" data-mp="1fwcufie8ah1k">
            "{SITE.tagline}"
          </p>
        </motion.div>
      </div>
    </section>;
}